import React from "react";
import FirebaseAuthContext from "./FirebaseAuthContext.js";

export default function useFirebaseAuth() {
  return React.useContext(FirebaseAuthContext);
}
